$(document).ready(function(){
    $('.services-overview-module-container').each(function(){
        var $self = $(this);
        var $tabsContainer = $self.find('.so-tabs');
        var $tabs = $tabsContainer.find('.so-tab');
        var $contents = $self.find('.so-contents .so-content');


        $tabs.on('hover', function(){
            var $tab = $(this);
            var index = $tab.attr('data-tab');

            $tabs.not($tab).removeClass('active');
            $tab.addClass('active');

            var $activeContent = $contents.filter(function(){
                return $(this).attr('data-content-for-tab') == index;
            });

            $contents.not($activeContent).removeClass('active');
            $activeContent.addClass('active');
        });
    });
})